export default "__VITE_ASSET__D7on3Cj8__"